import React from "react";
import Loader from 'react-loader-spinner'
import ModernBg1 from "../../components/ModernBg1";
import { checkTranslation, imageAddress, translate } from "../../utils/useful";
import LoaderButton from "../../components/LoaderButton";
import HttpServices from "../../utils/Http.services";
import ButtonAnimated from "../../components/buttons/ButtonAnimated";


class AddPermissionHome extends React.Component {
  state = {
    // isLoadingRemove: false,
    // id: null,
    // index: null,
    selecteds: {},
    groupsTempData: [],
    image: '',
    tab: 'roles'
  }

  // images=["001-man.svg",'011-woman.svg','012-woman.svg','019-man.svg','022-man.svg','025-man.svg','027-woman.svg','033-woman.svg','035-man.svg','038-man.svg','042-man.svg','043-woman.svg','049-woman.svg','050-woman.svg']

  componentDidMount() {
    // this.changeImage()
    //  this.interval = setInterval(() => {
    //   this.changeImage()
    // }, 1500);
    this.fetchUsers()
    this.fetchGroups()


    this.setState({ selecteds: {} }, () => {
      let types = ['role', 'hub', 'group']
      let selecteds = {}

      types.forEach(type => {
        let parentType = type + 's'
        if (Array.isArray(this.props[parentType])) {
          this.props[parentType].forEach(element => {
            selecteds[element._id] = { ...element }
            selecteds[element._id].removed = false
            selecteds[element._id].init = true
            selecteds[element._id].type = type

            if (!this.props.currentRole) {
              selecteds[element._id].disabled = true
            }
          });

        }

      });

      this.setState({ selecteds })

    })

  }





  fetchUsers = () => {

    this.setState({ isLoadingUsers: true })

    // console.log({ appletHub: this.props.variables?.appletHub })
    // console.log('this.props.variables',this.props.variables )

    // { appletHub: this.props.variables?.appletHub }
    HttpServices.request('searchHubWithRelation', { }, (fetchResult, fetchError, fetchStatus) => {
      this.setState({ isLoadingUsers: false })

      // console.log(fetchResult, fetchError)

      if (fetchError) {
        return
      }
      this.setState({ hubs: fetchResult.info, rawHubs: fetchResult.info })

    })
  }



  fetchGroups = () => {

    this.setState({ isLoadingGroups: true })

    // console.log('this.props.variables',this.props.variables )

    let body = { applet: this.props.variables?.appletId, appletHub: this.props.variables?.appletHub, hub: this.props.variables?.appletHub, targetId: this.props.variables?.appletHub }

    // console.log(body)

    HttpServices.request('getConnectionGroups', body, (fetchResult, fetchError, fetchStatus) => {

      // console.log(fetchResult, fetchError)

      this.setState({ isLoadingGroups: false })

      if (fetchError) {
        return
      }
      this.setState({ groups: fetchResult.info, rawGroups: fetchResult.info })

    })
  }


  onDone = () => {
    let selecteds = this.state.selecteds
    let final = []
    Object.values(selecteds).forEach(element => {
      final.push(element)
    });
    this.props.onDone(final, 'hub', () => {
    })

  }


  setTab = (tab) => {
    this.setState({ tab })
  }
  // componentWillUnmount() {
  //   clearInterval(this.interval)
  // }

  // changeImage = () => {
  //   let number = Math.floor(Math.random() * this.images.length - 1)
  //   if (this.images[number]) {
  //     let image = this.images[number]
  //     this.setState({ image })
  //   }
  // }


  changeSelect = (prop, type) => {

    // console.log(prop)
    if (!this.state.selecteds[prop._id]?.disabled) {
      let selecteds = this.state.selecteds
      if (!selecteds[prop._id] || selecteds[prop._id].removed) {
        // selecteds[prop._id] = { _id: prop._id, name: prop.name, hubs: prop.hubs, groups: prop.groups, fullname: prop.fullname, image: prop.image, type: type, username: prop.username }
        selecteds[prop._id] = prop
        selecteds[prop._id].type = type

      } else {
        if (selecteds[prop._id]?.owner && this.props.mainAccess) {
          this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: "The owner can not be removed from the main access list" })

          //= { id: prop._id, fullname:prop.fullname,type:prop.type,username:prop.username,uType:'user',removed: true, init: false }
        } else {
          delete selecteds[prop._id]
        }
      }

      // console.log(selecteds)


      this.setState({ selecteds })
    }
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }


  renderGroupOptions(fullData, options, level) {

    return (
      <div className="w-100 ">

        {Array.isArray(options) && (
          options.map((prop, index) => {
            let selected = false

            let childrenData = fullData.filter((a) => {
              let id = a.parent
              if (typeof id == 'object') {
                id = id?._id
              }
              return id == prop._id
            })

            selected = (this.state.selecteds[prop._id] && this.state.selecteds[prop._id].removed != true)
            let disabled = this.state.selecteds[prop._id]?.disabled

            return (
              <div >
                <div key={index} onClick={() => this.changeSelect(prop, 'group')} className="flexcb backHover pld-4 prd-4 pb-1 pt-1 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>

                  <div className="mb-1 mt-1 w-100 text-start flexcb" style={{ paddingLeft: level == null ? 0 : ((level ?? 0) * 10), paddingRight: 0, }}>
                    <p className="text-semibold text-normal">{prop.name}</p>

                    {prop.licensed && (
                      <div className='flexc br-20 ' style={{}}>
                        <img src="/assets/icons/applets/general/diamond-award.png" height={20} alt="" />
                      </div>
                    )}
                  </div>

                </div>

                {Array.isArray(childrenData) && childrenData.length > 0 && (
                  <div >
                    {this.renderGroupOptions(fullData, childrenData, (level + 1))}
                  </div>
                )}

              </div>
            )
          })
        )}




      </div>
    )
  }


  searchGroups = async (value) => {

    this.setState({ groupSearchtitle: value })


    if (value == "") {
      console.log(this.state.groupsTempData)

      await this.setState({ groups: this.state.groupsTempData }, () => {
        this.setState({ groupsTempData: [] })
      })

    } else {
      if (this.state.groupsTempData.length == 0) {
        await this.setState({ groupsTempData: [...this.state.groups] })
      }
      let values = []
      console.log(this.state.groupsTempData)
      this.state.groupsTempData.forEach(element => {
        if (String(element.name).toLowerCase().includes(String(value).toLowerCase())) {
          values.push(element)
        }
      })


      this.addParents(this.state.groupsTempData, values)

      console.log(values)
      this.setState({ groups: values }, () => {
      })

    }
  }



  addParents = (allData, values) => {

    values.forEach(value => {
      if (value.parent) {

        this.findParents(allData, values, value.parent)

      }
    });
  }

  findParents = (allData, values, parentId) => {

    let parents = allData.filter((a) => {
      let id = parentId
      if (typeof id == 'object') {
        id = id?._id
      }
      return a._id == id
    })

    if (parents[0]) {
      let found = false

      for (let i = 0; i < values.length; i++) {
        const element = values[i];
        if (element._id == parents[0]._id) {
          found = true
        }
      }
      if (!found) {
        values.push(parents[0])
      }

      if (parents[0].parent) {
        this.findParents(allData, values, parents[0].parent)

      }
    }
  }

  render() {

    let parentGroupsData = this.state.groups
    if (Array.isArray(parentGroupsData)) {
      parentGroupsData = parentGroupsData.filter((a) => a.parent == null)
    }

    return (
      <div className="pt-0 h-100" style={{}}>

        {/* <ModernBg1 /> */}

        <div className="position-relative h-100 d-flex flex-column">
          <div className="w-100" >
            <div className="px-3 flexcb pt-1 pb-0 " style={{ borderRadius: '8px 8px 0px 0px' }}>
              {this.props.currentRole ? (
                <p className="mt-0 text-normal text-bold ">{translate("Assign to ")} {this.props.currentRole?.name}</p>
              ) : (
                <p className="mt-0 text-normal text-bold ">{translate("Add new access")}</p>
              )}

              <div className="flexc">

                <ButtonAnimated
                  onClick={() => this.onDone()}
                  isLoading={this.state.isLoadingPost}
                  title={translate("Submit")}
                  bg='linear-gradient(45deg, #0094FF 0%, #6100FF 100%)'
                  className={'button-interactive-1 py-1 px-2'}
                  language={this.props.language}
                />

              </div>
              {/* <p className=" text-small  ">{translate("You want to give new access to users or groups?")}</p> */}
            </div>


            {!this.props.isLoading && (
              <div className="flexc px-2 pb-0 " style={{ borderBottom: '1px solid #eee' }}>

                {/* onClick={() => this.props.onDone('users')} */}
                {!this.props.currentRole && (
                  <button onClick={() => this.setState({ tab: 'roles' })} className=" pb-2 pt-0 px-2  text-center  flexc" style={{ borderBottom: this.state.tab == 'roles' ? '2px solid #007aff' : '2px solid transparent' }}>
                    {/* <img className="mrd-2" src={'/assets/icons/useful/user.png'} alt="" height="16px" /> */}
                    <p className="font-size-14 text-bold  p-0  " >{translate('Roles')}</p>
                    {/* <p className="text-smaller mt-0 p-0" >{translate('ca.new access for one or more users')}</p> */}

                  </button>
                )}


                <button onClick={() => this.setState({ tab: 'hubs' })} className=" pb-2 pt-0 px-2  text-center  flexc" style={{ borderBottom: this.state.tab == 'hubs' ? '2px solid #007aff' : '2px solid transparent' }}>
                  {/* <img className="mrd-2" src={'/assets/icons/useful/user (1).png'} alt="" height="15px" /> */}
                  <p className="font-size-14 text-bold  p-0  " >{translate('Hubs')}</p>
                  {/* <p className="text-smaller mt-0 p-0" >{translate('ca.new access for one or more users')}</p> */}

                </button>
                <button onClick={() => this.setState({ tab: 'groups' })} className=" pb-2 pt-0 px-2  text-center flexc " style={{ borderBottom: this.state.tab == 'groups' ? '2px solid #007aff' : '2px solid transparent' }}>
                  {/* <img className="mrd-2" src={'/assets/icons/useful/users.png'} alt="" height="16px" /> */}
                  <p className="font-size-14 text-bold  p-0 " >{translate("ca.Groups")}</p>
                  {/* <p className="text-smaller mt-0 p-0" >{translate('ca.new access for one or more groups')}</p> */}

                </button>
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {this.props.isLoading && (
                <Loader
                  type="Puff"
                  color="rgba(0,122,255,1)"
                  height="40"
                  width="40"
                />)}
            </div>

          </div>

          <div className="flex-1 sc-gray2 overflow-auto w-100 pt-1 pb-5">

            {this.state.tab == 'roles' && (
              <div className="">
                {this.props.allRoles?.length == 0 && (
                  <div className="px-3 py-2">
                    <p className="text-small text-semibold">{translate("No role is available")}</p>
                  </div>
                )}
                {this.props.allRoles?.map((role, index) => {

                  let selected = (this.state.selecteds[role._id] && this.state.selecteds[role._id].removed != true)
                  let disabled = this.state.selecteds[role._id]?.disabled

                  return (

                    <div key={index} onClick={() => this.changeSelect(role, 'role')} className="flexcb backHover pld-4 prd-4 pb-1 pt-1 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>

                      <button className="mb-1 mt-1 w-100 text-start">
                        <p className="text-semibold text-normal">{role.name}</p>
                      </button>

                    </div>
                  )
                })}
              </div>
            )}

            {this.state.tab == 'hubs' && (
              <div className="">
                {this.state.hubs?.length == 0 && (
                  <p>{translate("No user is available")}</p>
                )}

                {this.state.hubs && (
                  <>
                    <div className="px-2 mb-2 mt-1">
                      <div className="w-100 mb-0 px-3  py-1 br-30" style={{ backgroundColor: '#f2f2f2', }}>
                        <input onChange={(e) => this.search(e.target.value)} placeholder={translate("Search hubs")} className="w-100 text-semibold" style={{ height: 30, fontSize: 14, background: 'transparent', borderRadius: 6, border: '0px solid #eee' }} />
                      </div>
                    </div>
                    {this.state.hubs?.map((item, index) => {

                      let selected = (this.state.selecteds[item._id] && this.state.selecteds[item._id].removed != true)
                      let disabled = this.state.selecteds[item._id]?.disabled

                      return (

                        <div key={index} onClick={() => this.changeSelect(item, 'hub')} className="flexcb backHover pld-4 prd-4 pb-1 pt-1 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>
                          <div className="flexc">
                            <div className="flexcc">
                              <img src={imageAddress(item.image, 'profile', 'thumb')} width="36px" style={{ borderRadius: 50, height: 36, objectFit: 'cover' }} alt="" />
                            </div>
                            <div className="px-2">
                              <p className="text-small text-semibold  ">{item.fullname}</p>

                              {item.username ? (
                                <p className="text-smaller " style={{ color: '#789' }}>@{item.username}</p>

                              ) : (
                                <p className="text-smaller " style={{ color: '#789' }}>{translate('ca.Virtual User')}</p>

                              )}
                            </div>
                          </div>
                          <div className="flexc">
                            {item.relation?.licensed && (
                              <div className='flexc br-20 ' style={{}}>
                                <img src="/assets/icons/applets/general/diamond-award.png" height={20} alt="" />
                              </div>
                            )}

                            {item.relation && (
                              <div className='flexc br-20 mld-2 opacity-5' style={{}}>
                                <img src="/assets/icons/useful/link (4).png" height={16} alt="" />
                              </div>
                            )}

                          </div>

                        </div>
                      )
                    })}
                  </>
                )}
              </div>
            )}



            {this.state.tab == 'groups' && (

              <>
                <div className="px-2 mb-1 mt-1">
                  <div className="w-100 mb-0 px-3  py-1 br-30" style={{ backgroundColor: '#f2f2f2', }}>
                    <input value={this.state.groupSearchtitle} onChange={(e) => this.searchGroups(e.target.value)} placeholder={translate("Search groups")} className="w-100 text-semibold" style={{ height: 30, fontSize: 14, background: 'transparent', borderRadius: 6, border: '0px solid #eee' }} />
                  </div>
                </div>

                <div className="">
                  {this.state.groups?.length == 0 && (
                    <p>{translate("No group is available")}</p>
                  )}


                  {this.renderGroupOptions(this.state.groups, parentGroupsData, 0)}

                  {/* {this.state.groups?.map((item, index) => {

                    let selected = (this.state.selecteds[item._id] && this.state.selecteds[item._id].removed != true)
                    let disabled = this.state.selecteds[item._id]?.disabled

                    return (

                      <div key={index} onClick={() => this.changeSelect(item, 'group')} className="flexcb backHover pld-4 prd-4 pb-1 pt-1 cursor-pointer transition-all" style={{ borderLeft: selected ? (disabled ? '5px solid #aaa ' : '5px solid #1379ff ') : null, borderBottom: '0px solid ' + (selected ? (disabled ? '#f2f2f2' : '#e0e0ef60') : '#f6f6f6'), backgroundColor: (selected ? (disabled ? '#f2f2f2' : '#1379ff10 ') : 'transparent') }}>

                        <div className="mb-1 mt-1 w-100 text-start flexcb">
                          <p className="text-semibold text-normal">{item.name}</p>

                          {item.licensed && (
                            <div className='flexc br-20 ' style={{}}>
                              <img src="/assets/icons/applets/general/diamond-award.png" height={20} alt="" />
                            </div>
                          )}
                        </div>

                      </div>
                    )
                  })} */}
                </div>

              </>
            )}


          </div>
        </div>
      </div >

    );
  }
}



export default AddPermissionHome;
